import { ContentGridBreakpoint } from "features/CenterContent/VehicleDetails/TrainDetails/TrainComposition/TrainSummary/TrainSummary";
import { TodoOploggSidebar } from "features/TodoOploggSidebar/TodoOploggSidebar";
import VehicleSidebar from "features/VehicleSidebar/VehicleSidebar";
import { FC } from "react";
import { Outlet } from "react-router-dom";
import { Box, tokens } from "shared/components/Spor";
import { hideOnWidthStyle } from "shared/utils/hideOnWidth";
import { useDropsRole } from "stores/useDropsRole";
import { useStretchBuilder } from "stores/useStretchBuilder";
import styled from "styled-components";

const CenterContentWrapper = styled(Box)<{ $modal: boolean }>`
  grid-area: main;
  box-sizing: border-box;
  justify-self: stretch;
  min-height: 0; // https://css-tricks.com/preventing-a-grid-blowout/
  height: 100%;
  display: flex;
  flex-direction: column;
  z-index: ${({ $modal }) =>
    $modal
      ? tokens.default.depth["z-index"].overlay
      : tokens.default.depth["z-index"].base};
  ${hideOnWidthStyle(ContentGridBreakpoint)};
  min-width: 700px;
`;

export const DashboardLayout: FC = () => {
  const [isStretchBuilderMode] = useStretchBuilder(
    (state) => [state.isStretchBuilderMode],
    Object.is,
  );
  const { isDriftledningen } = useDropsRole();
  return (
    <>
      <VehicleSidebar />
      <CenterContentWrapper $modal={isStretchBuilderMode()}>
        <Outlet />
      </CenterContentWrapper>
      {!isDriftledningen() && <TodoOploggSidebar />}
    </>
  );
};
